function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
import SVGArray from './SVGArray.js';
import parser from '../modules/core/parser.js';
import Box from './Box.js';
import { pathParser } from '../utils/pathParser.js';
function arrayToString(a) {
    var s = '';
    for(var i = 0, il = a.length; i < il; i++){
        s += a[i][0];
        if (a[i][1] != null) {
            s += a[i][1];
            if (a[i][2] != null) {
                s += ' ';
                s += a[i][2];
                if (a[i][3] != null) {
                    s += ' ';
                    s += a[i][3];
                    s += ' ';
                    s += a[i][4];
                    if (a[i][5] != null) {
                        s += ' ';
                        s += a[i][5];
                        s += ' ';
                        s += a[i][6];
                        if (a[i][7] != null) {
                            s += ' ';
                            s += a[i][7];
                        }
                    }
                }
            }
        }
    }
    return s + ' ';
}
var PathArray = /*#__PURE__*/ function(SVGArray) {
    "use strict";
    _inherits(PathArray, SVGArray);
    function PathArray() {
        _class_call_check(this, PathArray);
        return _call_super(this, PathArray, arguments);
    }
    _create_class(PathArray, [
        {
            // Get bounding box of path
            key: "bbox",
            value: function bbox() {
                parser().path.setAttribute('d', this.toString());
                return new Box(parser.nodes.path.getBBox());
            }
        },
        {
            // Move path string
            key: "move",
            value: function move(x, y) {
                // get bounding box of current situation
                var box = this.bbox();
                // get relative offset
                x -= box.x;
                y -= box.y;
                if (!isNaN(x) && !isNaN(y)) {
                    // move every point
                    for(var l, i = this.length - 1; i >= 0; i--){
                        l = this[i][0];
                        if (l === 'M' || l === 'L' || l === 'T') {
                            this[i][1] += x;
                            this[i][2] += y;
                        } else if (l === 'H') {
                            this[i][1] += x;
                        } else if (l === 'V') {
                            this[i][1] += y;
                        } else if (l === 'C' || l === 'S' || l === 'Q') {
                            this[i][1] += x;
                            this[i][2] += y;
                            this[i][3] += x;
                            this[i][4] += y;
                            if (l === 'C') {
                                this[i][5] += x;
                                this[i][6] += y;
                            }
                        } else if (l === 'A') {
                            this[i][6] += x;
                            this[i][7] += y;
                        }
                    }
                }
                return this;
            }
        },
        {
            // Absolutize and parse path to array
            key: "parse",
            value: function parse() {
                var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'M0 0';
                if (Array.isArray(d)) {
                    d = Array.prototype.concat.apply([], d).toString();
                }
                return pathParser(d);
            }
        },
        {
            // Resize path string
            key: "size",
            value: function size(width, height) {
                // get bounding box of current situation
                var box = this.bbox();
                var i, l;
                // If the box width or height is 0 then we ignore
                // transformations on the respective axis
                box.width = box.width === 0 ? 1 : box.width;
                box.height = box.height === 0 ? 1 : box.height;
                // recalculate position of all points according to new size
                for(i = this.length - 1; i >= 0; i--){
                    l = this[i][0];
                    if (l === 'M' || l === 'L' || l === 'T') {
                        this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                        this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
                    } else if (l === 'H') {
                        this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                    } else if (l === 'V') {
                        this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
                    } else if (l === 'C' || l === 'S' || l === 'Q') {
                        this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                        this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
                        this[i][3] = (this[i][3] - box.x) * width / box.width + box.x;
                        this[i][4] = (this[i][4] - box.y) * height / box.height + box.y;
                        if (l === 'C') {
                            this[i][5] = (this[i][5] - box.x) * width / box.width + box.x;
                            this[i][6] = (this[i][6] - box.y) * height / box.height + box.y;
                        }
                    } else if (l === 'A') {
                        // resize radii
                        this[i][1] = this[i][1] * width / box.width;
                        this[i][2] = this[i][2] * height / box.height;
                        // move position values
                        this[i][6] = (this[i][6] - box.x) * width / box.width + box.x;
                        this[i][7] = (this[i][7] - box.y) * height / box.height + box.y;
                    }
                }
                return this;
            }
        },
        {
            // Convert array to string
            key: "toString",
            value: function toString() {
                return arrayToString(this);
            }
        }
    ]);
    return PathArray;
}(SVGArray);
export { PathArray as default };
